import React from "react";
import { CCard, CCardBody, CCardHeader } from "@coreui/react";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <CCard className="privacy-card">
        <CCardHeader className="privacy-header">
          <h2>Privacy Policy</h2>
          <small>Last updated: Nov 23, 2023</small>
        </CCardHeader>

        <CCardBody className="privacy-body">
          <p>
            This Privacy Policy describes Our policies and procedures on the
            collection, use and disclosure of Your information when You use the
            Service and tells You about Your privacy rights and how the law
            protects You.
          </p>

          <p>
            We use Your Personal data to provide and improve the Service. By
            using the Service, You agree to the collection and use of
            information in accordance with this Privacy Policy.
          </p>

          <h4>Interpretation and Definitions</h4>

          <h5>Interpretation</h5>
          <p>
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>

          <h5>Definitions</h5>
          <p>For the purposes of this Privacy Policy:</p>

          <ul>
            <li>
              <strong>Account</strong> means a unique account created for You to
              access our Service or parts of our Service.
            </li>
            <li>
              <strong>Affiliate</strong> means an entity that controls, is
              controlled by or is under common control with a party.
            </li>
            <li>
              <strong>Application</strong> refers to Ezybuy, the software
              program provided by the Company.
            </li>
            <li>
              <strong>Company</strong> refers to Conjoinix Total Solutions
              Private Limited, SCO 193-194-195, Sector 34B, Sector 34,
              Chandigarh, 160022.
            </li>
            <li>
              <strong>Cookies</strong> are small files placed on Your device.
            </li>
            <li>
              <strong>Country</strong> refers to Chandigarh, India.
            </li>
            <li>
              <strong>Device</strong> means any device that can access the
              Service.
            </li>
            <li>
              <strong>Personal Data</strong> is any information relating to an
              identifiable individual.
            </li>
            <li>
              <strong>Service</strong> refers to the Application or the Website
              or both.
            </li>
            <li>
              <strong>Service Provider</strong> means any third-party processing
              data on behalf of the Company.
            </li>
            <li>
              <strong>Usage Data</strong> refers to data collected
              automatically.
            </li>
            <li>
              <strong>You</strong> means the individual accessing or using the
              Service.
            </li>
          </ul>

          <h4>Collecting and Using Your Personal Data</h4>

          <h5>Types of Data Collected</h5>

          <h6>Personal Data</h6>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>User Photo</li>
            <li>Usage Data</li>
          </ul>

          <h6>Usage Data</h6>
          <p>
            Usage Data is collected automatically when using the Service and may
            include IP address, browser type, browser version, pages visited,
            time and date of visit, time spent on pages, and device identifiers.
          </p>

          <h5>Information Collected while Using the Application</h5>
          <p>
            While using Our Application, We may collect, with Your permission:
          </p>

          <ul>
            <li>Location information</li>
            <li>Contacts list</li>
            <li>User photographs and media</li>
            <li>Camera and photo library data</li>
            <li>Device information</li>
          </ul>

          <p>
            Data may be uploaded to Company servers or Service Provider servers,
            including internal or third-party services such as:
            <strong> adnetapi.conjoinix.com</strong>
          </p>

          <h4>How do we use your information?</h4>
          <ul>
            <li>Personalization of experience</li>
            <li>Improve services and user experience</li>
            <li>Administer promotions, surveys, or contests</li>
            <li>Send periodic emails</li>
            <li>Follow up on communications</li>
          </ul>

          <h4>How do we protect your information?</h4>
          <p>
            Your information is stored in secured networks and accessible only
            by authorized personnel. SSL encryption and security measures are
            used to protect your data.
          </p>

          <h4>Do we use cookies?</h4>
          <p>
            Yes. Cookies help recognize users and improve experience. You may
            disable cookies through your browser settings, though some features
            may not function properly.
          </p>

          <h4>Third-party Disclosure</h4>
          <p>
            Personally Identifiable Information is not sold, traded, or
            transferred to outside parties.
          </p>

          <h4>App Permissions Disclosure</h4>
          <ul>
            <li>CAMERA</li>
            <li>READ CONTACTS</li>
            <li>ACCESS FINE LOCATION</li>
            <li>ACCESS COARSE LOCATION</li>
            <li>READ PHONE STATE</li>
            <li>GET ACCOUNTS</li>
            <li>RECEIVE SMS</li>
            <li>READ / WRITE EXTERNAL STORAGE</li>
          </ul>

          <h4>Delete Your Personal Data</h4>
          <p>
            You can request deletion by emailing:
            <strong> sales@conjoinix.com</strong>. We may require up to 7 days
            to process your request.
          </p>

          <h4>Delete Account Request</h4>
          <p>
            <a
              href="https://ezybuy.shop/deleteUser?userId=U2FsdGVkX1%2FmQFKXrYZ0zX6r0x1AMxp%2BlBZ3ZQq4Vm4%3D"
              target="_blank"
              rel="noreferrer"
            >
              Delete My Account
            </a>
          </p>

          <h4>Contact Us</h4>
          <p>
            If you have any questions about this Privacy Policy, contact us at:
            <strong> sales@conjoinix.com</strong>
          </p>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default PrivacyPolicy;
